module.exports = __webpack_public_path__ + "static/img/4.5a07430.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/4.png
// module id = BCEL
// module chunks = 4